import { IComponent } from '@/services/component';
import { CheckList } from './';

export const titles = {
  IMAGERY: 'Add component imagery',
  NAME: 'Add component name',
  PRICING: 'Add pricing information',
  PROPERTIES: 'Add component properties',
  VENDORS: 'List the suppliers of this component',
};

export default [
  {
    title: titles.IMAGERY,
    isComplete: data => data.assets && data.assets.length,
    meta: {
      category: 'General Information',
    },
  },
  {
    title: titles.NAME,
    isComplete: data => !!data.name,
    meta: {
      category: 'General Information',
    },
  },
  {
    title: titles.PRICING,
    isComplete: data => (
      data.prices.length
        && !data.prices.find(price => !price.amount || !price.category || !price.currency)
    ),
    meta: {
      category: 'General Information',
    },
  },
  {
    title: titles.PROPERTIES,
    isComplete: data => (
      data.properties.length
        && !data.properties.find(prop => !prop.key || !prop.value)
    ),
    meta: {
      category: 'General Information',
    },
  },
  {
    title: titles.VENDORS,
    isComplete: data => data.vendors && data.vendors.length,
    meta: {
      category: 'General Information',
    },
  },
] as Array<CheckList<IComponent>>;
